import { useQuery } from '@tanstack/react-query';

export type SectionOptions = {
  agents: string[];
  domainFilters: string[];
};

export const useSectionOptions = () => {
  const { data, isLoading, isError, error } = useQuery<SectionOptions>({
    queryKey: ['admin', 'templates', 'section-options'],
    staleTime: Infinity,
  });

  return {
    sectionOptions: data,
    isLoading,
    isError,
    error,
  };
};
